import { assert_instanceof, assert_is_null, assert_type_function } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__field_kind } from '../../_enums/ENUM__field_kind';
import { CONSTRUCTOR_FIELD_BASE } from '../../_fields/_base/CONSTRUCTOR_FIELD_BASE';
import { CONSTRUCTOR_FIELD_CONTAINER } from '../../_fields/_base/CONSTRUCTOR_FIELD_CONTAINER';
import { DTO_META__field_info } from '../../_fields/_base/DTO_META__field_info';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { FN_FIELD__apply_init_options } from './FN_FIELD__apply_init_options';

export class FIELD_INITIALIZER__base extends DTO__base {
  /*
   * REGISTER
   */

  static init_as_input<T_FIELD extends FIELD__base>(
    this: new () => T_FIELD,
    options_field: Partial<T_FIELD> = {},
    options_meta: Partial<DTO_META__field_info> = {},
  ) {
    options_meta = { ui__is_readonly: false, field_kind: ENUM__field_kind.INPUT, ...options_meta };

    let class_object = this as CONSTRUCTOR_FIELD_BASE<T_FIELD>;

    options_meta = { ...class_object.get_meta_params_default(), ...options_meta };

    return class_object.init_as_field(options_field, options_meta);
  }

  static init_as_output<T_FIELD extends FIELD__base>(
    this: new () => T_FIELD,
    options_field: Partial<T_FIELD> = {},
    options_meta: Partial<DTO_META__field_info> = {},
  ) {
    let class_object = this as CONSTRUCTOR_FIELD_BASE<T_FIELD>;

    options_meta = { grid2d__can_be_dimension: false, ui__is_readonly: true, field_kind: ENUM__field_kind.OUTPUT, ...options_meta };

    options_meta = { ...class_object.get_meta_params_default(), ...options_meta };

    return class_object.init_as_field(options_field, options_meta);
  }

  static init_as_field<T_FIELD extends FIELD__base>(
    this: new () => T_FIELD,
    options_field: Partial<T_FIELD> = {},
    options_meta: Partial<DTO_META__field_info> = {},
  ) {
    const class_object = this as unknown as CONSTRUCTOR_FIELD_CONTAINER<T_FIELD>;

    return function (value: any, context: ClassFieldDecoratorContext) {
      return function (this: any, initial_value: any) {
        let field_name = context.name.toString();

        let target_field = this[field_name];

        let field_options_meta = { ...class_object.get_meta_params_default(), ...options_meta };

        assert_is_null(target_field);

        /*
         * INIT
         */

        target_field = new class_object();

        FN_FIELD__apply_init_options(target_field, options_field);

        /*
         *
         */

        assert_instanceof(target_field, FIELD__base);

        target_field.meta = new DTO_META__field_info().clone(field_options_meta);
        target_field.meta.id_create();

        assert_type_function(target_field.post_init);

        target_field.post_init();

        initial_value = target_field;

        return initial_value;
      };
    };
  }

  static partial<T_FIELD extends FIELD__base>(this: new () => T_FIELD, options_field: Partial<T_FIELD> = {}, options_meta: Partial<DTO_META__field_info> = {}) {
    let constructor = this as unknown as CONSTRUCTOR_FIELD_CONTAINER<T_FIELD>;

    options_meta = { ...constructor.get_meta_params_default(), ...options_meta };

    let out = new this() as T_FIELD;
    out = out.clone({ ...options_field });
    out.meta = new DTO_META__field_info().clone(options_meta);
    return out;
  }

  //==================================
}
